import { render, staticRenderFns } from "./menu-item-group.vue?vue&type=template&id=576f4de8&scoped=true&"
import script from "./menu-item-group.vue?vue&type=script&lang=js&"
export * from "./menu-item-group.vue?vue&type=script&lang=js&"
import style0 from "./menu-item-group.vue?vue&type=style&index=0&id=576f4de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576f4de8",
  null
  
)

export default component.exports